var map = {
	"./all_games_banner.svg": 80888,
	"./banner-example.png": 73832,
	"./banner-guide.png": 7390,
	"./banner00.png": 1141,
	"./banner00.spine.mp4": 95379,
	"./banner01.png": 78748,
	"./banner02.png": 31942,
	"./banner03.png": 20986,
	"./banner04.png": 47537,
	"./banner05.png": 73207,
	"./banner06.png": 18927,
	"./game-list-box.png": 12136,
	"./quick-join-box.png": 97634,
	"./quick-join-icon.png": 82521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13554;